const CDN_URL = "https://pub-263296a03d7d4d0fad026af20f628ecb.r2.dev";

export const ASSETS = {
    icon: `${CDN_URL}/website/techwatch_icon.png`,
    icon_circle: `${CDN_URL}/website/techwatch_icon_circle.png`,
    default_item: `${CDN_URL}/website/circle-item-solid-full.png`,
    default_avatar: `${CDN_URL}/website/avatar.png`,
    logo_top: `${CDN_URL}/website/techwatch_logo_1.png`,
    logo_side: `${CDN_URL}/website/techwatch_logo_2.png`,
};
